import type { Language } from '../types';

interface FlagProps {
	className?: string;
}

export function FlagGB({ className = 'w-5 h-3.5' }: FlagProps) {
	return (
		<svg
			viewBox='0 0 640 480'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			aria-label='English (United Kingdom)'
		>
			<path fill='#012169' d='M0 0h640v480H0z' />
			<path fill='#FFF' d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z' />
			<path
				fill='#C8102E'
				d='m424 288 182 135h34v-23L456 270h-32zm-208-96L34 57H0v23l184 137h32zm25-10v116h-76v-16l80-59v-41h-4zm158 138v-40h4l76 56v16h-80z'
			/>
			<path fill='#FFF' d='M240 0v480h160V0H240zM0 160v160h640V160H0z' />
			<path fill='#C8102E' d='M266 0v480h108V0H266zM0 186v108h640V186H0z' />
		</svg>
	);
}

export function FlagIT({ className = 'w-5 h-3.5' }: FlagProps) {
	return (
		<svg viewBox='0 0 640 480' className={className} xmlns='http://www.w3.org/2000/svg' aria-label='Italiano'>
			<g fillRule='evenodd' strokeWidth='1pt'>
				<path fill='#009246' d='M0 0h213.3v480H0z' />
				<path fill='#ffffff' d='M213.3 0h213.4v480H213.3z' />
				<path fill='#ce2b37' d='M426.7 0H640v480H426.7z' />
			</g>
		</svg>
	);
}

export function FlagFR({ className = 'w-5 h-3.5' }: FlagProps) {
	return (
		<svg viewBox='0 0 640 480' className={className} xmlns='http://www.w3.org/2000/svg' aria-label='Français'>
			<g fillRule='evenodd' strokeWidth='1pt'>
				<path fill='#0055a5' d='M0 0h213.3v480H0z' />
				<path fill='#ffffff' d='M213.3 0h213.4v480H213.3z' />
				<path fill='#ef4135' d='M426.7 0H640v480H426.7z' />
			</g>
		</svg>
	);
}

export function FlagDE({ className = 'w-5 h-3.5' }: FlagProps) {
	return (
		<svg viewBox='0 0 640 480' className={className} xmlns='http://www.w3.org/2000/svg' aria-label='Deutsch'>
			<path fill='#000000' d='M0 0h640v160H0z' />
			<path fill='#dd0000' d='M0 160h640v160H0z' />
			<path fill='#ffce00' d='M0 320h640v160H0z' />
		</svg>
	);
}

interface CountryFlagProps {
	code: Language | string;
	className?: string;
}

export function CountryFlag({ code, className = 'w-5 h-3.5' }: CountryFlagProps) {
	switch (code.toLowerCase()) {
		case 'en':
		case 'gb':
		case 'uk':
			return <FlagGB className={className} />;
		case 'it':
			return <FlagIT className={className} />;
		case 'fr':
			return <FlagFR className={className} />;
		case 'de':
			return <FlagDE className={className} />;
		default:
			return null;
	}
}

export default CountryFlag;
